// src/pages/sign-in/sign-in.component.class.jsx
import React from "react";
import { motion } from "framer-motion";

import Login from "../../components/login/login.component";
import Register from "../../components/register/register.component.class";
import ResetPassword from "../../components/reset-password/reset-password.component";
import Box from "../../components/retro/box/box.component";

import "./sign-in.styles.scss";

import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      yPos: 0,
      forgotPassword: false,
    };
  }

  render() {
    return (
      <div className="signIn">
        {/* <Box style={{ padding: "0px" }}> */}
          <div className="signIn__content">
            <motion.div
              className="signIn__scroll"
              animate={{ y: this.state.yPos }}
              transition={{ duration: 0.7, type: "spring" }}
            >
              <div className="signIn__login-content">
                <Login />
                <div className="signIn__forgotPassword">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() =>
                      this.setState({ forgotPassword: true }) &
                      this.setState({ yPos: "-200vh" })
                    }
                  >
                    Forgot Password?
                    <br />
                  </motion.p>
                </div>
                <div className="signIn__noAccount">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => this.setState({ yPos: "-100vh" })}
                  >
                    Don't have an account? <span>Register!</span>
                    <br />
                    <BsChevronCompactDown size="1.5em" />
                  </motion.p>
                </div>
              </div>
              <div className="signIn__register-content">
                <Register />
                <div className="signIn__noAccount">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => this.setState({ yPos: 0 })}
                  >
                    Already a member? <span>Login!</span>
                    <br />
                    <BsChevronCompactUp size="1.5em" />
                  </motion.p>
                </div>
              </div>
              <div className="signIn__reset-content">
                <ResetPassword />
                <div className="signIn__forgotPassword">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => this.setState({ yPos: 0 })}
                  >
                    Remembered all of a sudden? <span>Login!</span>
                    <br />
                  </motion.p>
                </div>
                <div className="signIn__noAccount">
                  <motion.p
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => this.setState({ yPos: "-100vh" })}
                  >
                    Don't have an account? <span>Register!</span>
                    <br />
                    <BsChevronCompactUp size="1.5em" />
                  </motion.p>
                </div>
              </div>
            </motion.div>
          </div>
        {/* </Box> */}
      </div>
    );
  }
}

export default SignIn;
